/*
 *
 * ProcessingRulesForm
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 17-Jan-2025
 */

import ProcessingRulesForm from './ProcessingRulesFormContainer'

export default ProcessingRulesForm
